module.exports = __webpack_public_path__ + "static/img/4027be-1.6f286ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/4027be-1.svg
// module id = jIde
// module chunks = 0